import MapScale from '@/Enums/Map/MapScale.enum';
import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import ReportView from '@/Enums/ReportingDashboard/ReportView/ReportView.enum';
import ViewType from '@/Enums/ReportingDashboard/ViewType.enum';
import { ITotalReportRecord } from '@/Interfaces/ReportingDashboard/Beeswax/ReportRecord.interface';
import { IState } from '@/Interfaces/Slices/ReportingDashboard/Beeswax/State.interface';
import type { OmnichannelGraph, OmnichannelReportOnlyView } from '@/types/ReportingDashboard/Omnichannel.type';
import { DEFAULT_LOADING_REQUEST_ID } from '../slice';

export const defaultTotals: ITotalReportRecord = {
  [BeeswaxReportProperties.IMPRESSIONS]: 0,
  [BeeswaxReportProperties.SPEND]: 0,
  [BeeswaxReportProperties.REACH]: 0,
  [BeeswaxReportProperties.FREQUENCY]: 0,
  [BeeswaxReportProperties.VCR]: 0,
  [BeeswaxReportProperties.CTR]: 0,
  [BeeswaxReportProperties.LTR]: 0,
};

export const initialState: IState = {
  //#region report data
  totals: defaultTotals,

  //#region delivery
  dateDeliveryReport: [],
  weekDeliveryReport: [],
  monthDeliveryReport: [],
  quarterDeliveryReport: [],
  dayOfWeekDeliveryReport: [],
  deviceDeliveryReport: [],
  channelDeliveryReport: [],
  campaignDeliveryReport: [],
  advertiserDeliveryReport: [],
  creativeDeliveryReport: [],
  daypartDeliveryReport: [],
  placementDeliveryReport: [],
  publisherDeliveryReport: [],
  dealsDeliveryReport: [],
  contentNetworkDeliveryReport: [],
  contentChannelDeliveryReport: [],
  //#endregion
  //#region attribution
  dateAttributionReport: [],
  weekAttributionReport: [],
  monthAttributionReport: [],
  quarterAttributionReport: [],
  dayOfWeekAttributionReport: [],
  deviceAttributionReport: [],
  channelAttributionReport: [],
  campaignAttributionReport: [],
  advertiserAttributionReport: [],
  creativeAttributionReport: [],
  daypartAttributionReport: [],
  placementAttributionReport: [],
  publisherAttributionReport: [],
  dealsAttributionReport: [],
  dmaAttributionReport: [],
  stateAttributionReport: [],
  zipAttributionReport: [],
  countyAttributionReport: [],
  cityAttributionReport: [],
  congressionalDistrictAttributionReport: [],
  //#endregion
  //#endregion

  //#region filters
  campaigns: [],
  placementOptions: [],
  //#endregion

  //#region geo
  dmaDeliveryReport: [],
  cityDeliveryReport: [],
  stateDeliveryReport: [],
  zipDeliveryReport: [],
  countyDeliveryReport: [],
  congressionalDistrictDeliveryReport: [],
  zipBoundariesData: null,
  stateBoundariesData: null,
  countyBoundariesData: null,
  congressionalDistrictBoundariesData: null,
  dmaBoundariesData: null,
  cityBoundariesData: null,

  //#region requestIds
  totalsRequestId: DEFAULT_LOADING_REQUEST_ID,
  //#endregion

  //#region delivery
  dateDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  weekDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  monthDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  quarterDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  deviceDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  channelDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  advertiserDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  campaignDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  creativeDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  dayOfWeekDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  daypartDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  publisherDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  placementDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  dealsDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  contentNetworkDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  contentChannelDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  dmaDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  zipDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  congressionalDistrictDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  countyDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  stateDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  cityDeliveryReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  //#endregion

  //#region attribution
  dateAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  weekAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  monthAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  quarterAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  deviceAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  channelAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  advertiserAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  campaignAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  creativeAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  dayOfWeekAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  daypartAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  publisherAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  placementAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  dealsAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  dmaAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  zipAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  cityAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  stateAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  countyAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  congressionalDistrictAttributionReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  //#endregion

  zipBoundariesDataRequestId: DEFAULT_LOADING_REQUEST_ID,
  cityBoundariesDataRequestId: DEFAULT_LOADING_REQUEST_ID,
  stateBoundariesDataRequestId: DEFAULT_LOADING_REQUEST_ID,
  countyBoundariesDataRequestId: DEFAULT_LOADING_REQUEST_ID,
  congressionalDistrictBoundariesDataRequestId: DEFAULT_LOADING_REQUEST_ID,
  dmaBoundariesDataRequestId: DEFAULT_LOADING_REQUEST_ID,
  //#endregion

  viewType: ViewType.Delivery,

  errorCardMessage: '',
};

export const beeswaxMapScales: MapScale[] = Object.values(MapScale);

export const beeswaxTimeScales: OmnichannelReportOnlyView[] = [ReportView.Week, ReportView.Month, ReportView.Quarter];

// Display order of the Impressions by Type tabs.
export const beeswaxImpressionsByTypeTabOrder: OmnichannelReportOnlyView[] = [
  ReportView.Channel,
  ReportView.Device,
  ReportView.Advertiser,
  ReportView.Campaign,
  ReportView.Placement,
  ReportView.Creative,
  ReportView.Publisher,
  ReportView.ContentNetwork,
  ReportView.ContentChannel,
  ReportView.DaysOfWeek,
  ReportView.Daypart,
  ReportView.Deals,
];

// The delivery report behind each standalone graph card on the Omnichannel view.
export const omnichannelGraphSources: Record<
  OmnichannelGraph,
  { tab: OmnichannelReportOnlyView; reportKey: keyof IState }
> = {
  date: { tab: ReportView.Date, reportKey: 'dateDeliveryReport' },
  channel: { tab: ReportView.Channel, reportKey: 'channelDeliveryReport' },
  device: { tab: ReportView.Device, reportKey: 'deviceDeliveryReport' },
  campaign: { tab: ReportView.Campaign, reportKey: 'campaignDeliveryReport' },
  creative: { tab: ReportView.Creative, reportKey: 'creativeDeliveryReport' },
  publisher: { tab: ReportView.Publisher, reportKey: 'publisherDeliveryReport' },
  dayOfWeek: { tab: ReportView.DaysOfWeek, reportKey: 'dayOfWeekDeliveryReport' },
  daypart: { tab: ReportView.Daypart, reportKey: 'daypartDeliveryReport' },
};
